module.exports = __webpack_public_path__ + "ca892829180810fea814621eb76836a5.jpg";